(function($) {
  $('.js-ellipsis').each(function() {
    var lines = this.getAttribute('data-ellipsis-lines') || 3;
    var child = null || this.getAttribute('data-ellipsis-selector');
    var el = !!child ? $(this).find(child)[0] : this
    new Dotdotdot(el, {
      height: 16 * 1.5 * lines
    })
  })
})(jQuery);